import { __assign } from 'tslib';
import * as React from 'react';

var SvgPlus = function SvgPlus(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 120 120"
  }, props), React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h120v120H0z"
  }), React.createElement("path", {
    d: "M4651.967-3630.794a4.953 4.953 0 0 0 1.351-3.514v-9.865a4.739 4.739 0 0 0-1.486-3.649 4.955 4.955 0 0 0-3.514-1.351H4627.1l-.068-21.285a4.626 4.626 0 0 0-1.351-3.514 4.539 4.539 0 0 0-3.581-1.419h-9.866a4.628 4.628 0 0 0-3.513 1.352 4.68 4.68 0 0 0-1.419 3.581l-.068 21.285-21.352.135a4.784 4.784 0 0 0-3.514 1.351 4.682 4.682 0 0 0-1.419 3.581l.068 9.8a4.366 4.366 0 0 0 1.419 3.581 4 4 0 0 0 3.513 1.352l21.285.067v21.353a4.31 4.31 0 0 0 1.352 3.513 3.779 3.779 0 0 0 3.581 1.419l9.8.068a5.435 5.435 0 0 0 3.581-1.419 4.955 4.955 0 0 0 1.351-3.514l.2-21.42h21.352a4.907 4.907 0 0 0 3.516-1.488Z",
    style: {
      opacity: 0.3
    },
    transform: "translate(-4556.356 3705.605)"
  }), React.createElement("path", {
    d: "M4651.967-3634.984a4.949 4.949 0 0 0 1.351-3.513v-9.866a4.739 4.739 0 0 0-1.486-3.648 4.96 4.96 0 0 0-3.514-1.352H4627.1l-.068-21.285a4.625 4.625 0 0 0-1.351-3.513 4.535 4.535 0 0 0-3.581-1.419h-9.866a4.624 4.624 0 0 0-3.513 1.351 4.682 4.682 0 0 0-1.419 3.581l-.068 21.285-21.352.135a4.785 4.785 0 0 0-3.514 1.352 4.682 4.682 0 0 0-1.419 3.581l.068 9.8a4.368 4.368 0 0 0 1.419 3.581 4 4 0 0 0 3.513 1.351l21.285.068v21.352a4.31 4.31 0 0 0 1.352 3.514 3.781 3.781 0 0 0 3.581 1.419l9.8.067a5.43 5.43 0 0 0 3.581-1.419 4.951 4.951 0 0 0 1.351-3.513l.2-21.42h21.352a4.908 4.908 0 0 0 3.516-1.489Z",
    style: {
      fill: "#afafaf"
    },
    transform: "translate(-4556.356 3705.605)"
  }), React.createElement("path", {
    d: "M4651.967-3641.354a4.952 4.952 0 0 0 1.351-3.514v-9.865a4.74 4.74 0 0 0-1.486-3.649 4.954 4.954 0 0 0-3.514-1.351H4627.1l-.068-21.285a4.626 4.626 0 0 0-1.351-3.514 4.538 4.538 0 0 0-3.581-1.419h-9.866a4.628 4.628 0 0 0-3.513 1.352 4.682 4.682 0 0 0-1.419 3.581l-.068 21.285-21.352.135a4.784 4.784 0 0 0-3.514 1.351 4.684 4.684 0 0 0-1.419 3.582l.068 9.8a4.37 4.37 0 0 0 1.419 3.582 4 4 0 0 0 3.513 1.351l21.285.068v21.352a4.312 4.312 0 0 0 1.352 3.514 3.781 3.781 0 0 0 3.581 1.419l9.8.067a5.429 5.429 0 0 0 3.581-1.419 4.954 4.954 0 0 0 1.351-3.513l.2-21.42h21.352a4.909 4.909 0 0 0 3.516-1.49Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-4556.356 3705.605)"
  }));
};

export { SvgPlus as default };